export const environment = {
  production: true,
  baseUrl:"https://vr-qa-mmsapi.azurewebsites.net/api/",
  msalConfig: {
      auth: {
          clientId: 'f85451e9-1d26-4416-81c6-792794016a35', //UI app registration client ID
          authority: 'https://login.microsoftonline.com/98f41971-1257-4f30-9db1-38dbbe1b231a', //UI app registraion authority from endpoints
          scopeUrls: [
              'api://f85451e9-1d26-4416-81c6-792794016a35/access_as_user' //API (azure function) scope
            ],
      }
  },
  apiConfig: {
      scopes: ['user.read'],
      uri: 'https://graph.microsoft.com/v1.0/me',

  }
};